import { Card } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { TrainingStats } from '@/hooks/useTrainingStats';
import { formatDistanceToNow } from 'date-fns';

interface RecentSessionsProps {
  stats: TrainingStats;
}

export function RecentSessions({ stats }: RecentSessionsProps) {
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}m ${secs}s`;
  };

  const getAccuracyColor = (correct: number, total: number) => {
    const rate = (correct / total) * 100;
    if (rate >= 75) return 'text-teen-green';
    if (rate >= 60) return 'text-teen-gold';
    return 'text-teen-orange';
  };

  if (stats.recentSessions.length === 0) {
    return (
      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">Recent Sessions</h3>
        <div className="text-center py-8 text-muted-foreground">
          No training sessions yet. Start training to see your history!
        </div>
      </Card>
    );
  }

  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Recent Sessions</h3>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Duration</TableHead>
              <TableHead>Positions</TableHead>
              <TableHead>Accuracy</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {stats.recentSessions.map((session, idx) => {
              const accuracy = Math.round((session.correctMoves / session.positionsAttempted) * 100);
              return (
                <TableRow key={session.sessionId || idx}>
                  <TableCell>
                    {formatDistanceToNow(new Date(session.date), { addSuffix: true })}
                  </TableCell>
                  <TableCell>{formatTime(session.totalTime)}</TableCell>
                  <TableCell>
                    {session.correctMoves}/{session.positionsAttempted}
                  </TableCell>
                  <TableCell className={getAccuracyColor(session.correctMoves, session.positionsAttempted)}>
                    {accuracy}%
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
}
